import { Spin, Typography } from "antd";

const FullscreenLoader = ({ visible, text }: { visible: boolean; text?: string }) => {
    if (!visible) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.55)",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "all",
            }}
        >
            <div
                style={{
                    padding: "32px 40px",
                    borderRadius: 16,
                    background: "#0f172a",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 16,
                }}
            >
                <Spin size="large" />
                <Typography.Text style={{ color: "#fff" }}>
                    {text || "Processing..."}
                </Typography.Text>
            </div>
        </div>
    );
};
export default FullscreenLoader;